<template>
    <suspense>
        <slot />
        <template #fallback>
            <div v-bind="attrs">
                <ProgressSpinner />
            </div>
        </template>
    </suspense>
</template>

<script setup>
import {useAttrs} from "vue";

const attrs = useAttrs()
</script>
